import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/asset-library/$assetId")({
  component: () => null,
})
